export default __webpack_public_path__ + "static/media/order.21b0115a.svg";